/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaEsercenteSummaryDTO } from '../model/models';
import { PraticaEsercenteEligibilitaDTO } from '../model/models';
import { TipoPraticaEsercenteListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetEligibilitaTipoPraticaEsercenteRequestParams {
    slug: string;
    idTp: string;
}

export interface ListTipiPraticaEsercenteRequestParams {
    slug: string;
    filter: TipoPraticaEsercenteListFilter;
    pageable: Pageable;
}


export interface EsercenteCatalogoBandiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Eleggibilita\&#39; al submit dell\&#39;esercente per un bando: { can_submit, reason } + riferimenti alla domanda gia\&#39; presentata, se esiste. reason e\&#39; una chiave di contratto sempre presente. 404 se il bando non e\&#39; visibile all\&#39;esercente.
     * 
     * @endpoint get /api/v1/esercente/comuni/{slug}/tipi-pratica/{idTp}/eligibilita
* @param requestParameters
     */
    getEligibilitaTipoPraticaEsercente(requestParameters: GetEligibilitaTipoPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteEligibilitaDTO>;

    /**
     * Lista paginata dei bandi partecipabili dall\&#39;esercente per un comune.
     * Filtro visibilità: isModuloEsercentiEnabled&#x3D;true + tipologia ammessa (EsercenteCompatibilityMatrix) + stato visibile. Filtri opzionali: tipologia, q (substring titolo+descrizione), partecipazione (APERTA/CHIUSA, assente &#x3D; tutti). 404 se lo slug non esiste. Default sort: data_apertura DESC.
     * @endpoint get /api/v1/esercente/comuni/{slug}/tipi-pratica
* @param requestParameters
     */
    listTipiPraticaEsercente(requestParameters: ListTipiPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaEsercenteSummaryDTO>;

}
